"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSubsystemWithMnemonic = exports.getSubsystemMnemonics = exports.evaluateStatus = exports.getMostSevereStatus = exports.getDayOfYear = exports.randomSeconds = exports.randomMinutes = exports.setSecondModulus = exports.setModulus = exports.generateEquipment = exports.shuffle = exports.between = exports.range = void 0;
const faker_1 = require("@faker-js/faker");
const options_1 = __importDefault(require("../data/options"));
const percentages_1 = __importDefault(require("../data/percentages"));
const _ = __importStar(require("lodash"));
const range = (options) => {
    if (typeof options === 'number') {
        return Array.from({ length: options }, (_, i) => 0 + i);
    }
    const { start, stop, step = 1 } = options;
    const length = (stop - start) / step + 1;
    return Array.from({ length }, (_, i) => start + i * step);
};
exports.range = range;
const between = (options) => {
    return faker_1.faker.number.int(options);
};
exports.between = between;
const shuffle = (arr) => {
    const shuffled = faker_1.faker.helpers.shuffle(arr);
    return shuffled[(0, exports.between)(arr.length - 1)];
};
exports.shuffle = shuffle;
const generateEquipment = () => {
    const shuffled = faker_1.faker.helpers.shuffle(options_1.default.equipments);
    const prefixes = shuffled.slice(0, (0, exports.between)({ min: 5, max: 7 }));
    const equipments = prefixes.map((prefix) => {
        return prefix + (0, exports.between)({ min: 1, max: 20 });
    });
    return equipments.sort().join(' ').toUpperCase();
};
exports.generateEquipment = generateEquipment;
const setModulus = (percentage) => {
    if (typeof percentage === 'number')
        return percentages_1.default[percentage];
    return 10;
};
exports.setModulus = setModulus;
const setSecondModulus = (percentage) => {
    if (typeof percentage === 'number')
        return percentages_1.default[percentage];
    return 50;
};
exports.setSecondModulus = setSecondModulus;
const randomMinutes = (min, max) => {
    return 1000 * 60 * (0, exports.between)({ min, max });
};
exports.randomMinutes = randomMinutes;
const randomSeconds = (min, max) => {
    return 1000 * (0, exports.between)({ min, max });
};
exports.randomSeconds = randomSeconds;
const getDayOfYear = (date) => {
    const start = Number(new Date(date.getFullYear(), 0, 0));
    const diff = Number(date) - start;
    const oneDay = 1000 * 60 * 60 * 24;
    const day = Math.floor(diff / oneDay);
    return day;
};
exports.getDayOfYear = getDayOfYear;
const getMostSevereStatus = (dataArray) => {
    if (dataArray.some((entity) => entity.status === 'critical')) {
        return 'critical';
    }
    if (dataArray.some((entity) => entity.status === 'serious')) {
        return 'serious';
    }
    if (dataArray.some((entity) => entity.status === 'caution')) {
        return 'caution';
    }
    if (dataArray.some((entity) => entity.status === 'normal')) {
        return 'normal';
    }
    if (dataArray.some((entity) => entity.status === 'standby')) {
        return 'standby';
    }
    return 'off';
};
exports.getMostSevereStatus = getMostSevereStatus;
const evaluateStatus = (currentValue, minThreshold, maxThreshold, seriousThresholdPercentage = 10, cautionThresholdPercentage = 20) => {
    if (currentValue >= maxThreshold || currentValue <= minThreshold)
        return 'critical';
    const acceptableRange = maxThreshold - minThreshold;
    const differenceToMax = maxThreshold - currentValue;
    const maxWithinPercentage = (differenceToMax / acceptableRange) * 100;
    const differenceToMin = currentValue - minThreshold;
    const minWithinPercentage = (differenceToMin / acceptableRange) * 100;
    if (maxWithinPercentage <= seriousThresholdPercentage ||
        minWithinPercentage <= seriousThresholdPercentage)
        return 'serious';
    if (maxWithinPercentage <= cautionThresholdPercentage ||
        minWithinPercentage <= cautionThresholdPercentage)
        return 'caution';
    return 'normal';
};
exports.evaluateStatus = evaluateStatus;
const getSubsystemMnemonics = (subsystems) => {
    const subsystemsMnemonics = [];
    subsystems.forEach((subsystem) => {
        subsystem.childSubsystems.forEach((childSubsystem) => {
            childSubsystem.assemblyDevices.forEach((assemblyDevices) => {
                subsystemsMnemonics.push(...assemblyDevices.mnemonics);
            });
        });
    });
    return subsystemsMnemonics;
};
exports.getSubsystemMnemonics = getSubsystemMnemonics;
const updateSubsystemWithMnemonic = (currentContact, params) => {
    const updateMnemonicOnSubsystem = (value) => {
        if (value.id === params.id) {
            return { ...value, ...params };
        }
    };
    const modifiedSubsystems = _.cloneDeepWith(currentContact.subsystems, updateMnemonicOnSubsystem);
    return modifiedSubsystems;
};
exports.updateSubsystemWithMnemonic = updateSubsystemWithMnemonic;
